{
  "version": 1,
  "asset_id": "75f50864-64bd-4a23-bedd-0d8aaca5ca80",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/75f50864-64bd-4a23-bedd-0d8aaca5ca80/svc-local-seo-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/75f50864-64bd-4a23-bedd-0d8aaca5ca80/svc-local-seo-1200.webp",
  "original_filename": "svc-local-seo-1200.webp",
  "size": 14388,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:54Z"
}
